import { $Q, $Qll } from './query-selector';
import { dataToggle } from './toggle-dataset';

export function openAccordion() {
  $Qll('.accordions').forEach((accordion) => {
    $Qll('.accordion-item', accordion).forEach((item, index) => {
      const textContent = $Q('.accordion-item__content', item);
      /**
       * If accordeons is type image
       */
      const imageText = $Q('.image-text', textContent);
      if(imageText){
        const imageTextContent = $Q('.image-text__description', textContent);
        let currentContent = null;
        if( imageTextContent.querySelector('.markdown') ){
          currentContent = decodeHtml(imageTextContent.innerHTML);
        }else{
          currentContent = imageTextContent.textContent;
        }
        const div = document.createElement("div");
        div.innerHTML = currentContent;
        imageTextContent.innerHTML = div.innerHTML;
      }

      /**
       * If accordeons is type text
       */

      const textSnippet = $Q('.text-snippet', textContent);
      if(textSnippet){
        const textSnippetContent = $Q('div', textContent);
        let currentContent = null;
        if( textSnippetContent.querySelector('.markdown') ){
          currentContent = decodeHtml(textSnippetContent.innerHTML);
        }else{
          currentContent = textSnippetContent.textContent;
        }
        const div = document.createElement("div");
        div.innerHTML = currentContent;
        textSnippetContent.innerHTML = div.innerHTML;
      }
      const accordion_button = $Q('.accordion-item__button', item)

      accordion_button.addEventListener('click', ()=> {
        if (accordion.dataset.toggle === 'false') {
          dataToggle(item);
          return;
        }

        $Qll('.accordion-item', accordion).forEach((ele, i) => {
          /**
           * Set toggle element if, the index is equal to target. Else the element is closed
           * **/
          parseInt(item.dataset.index) == i
            ? dataToggle(ele)
            : closeElement(ele);
        });
      });
    });
  });
}

function closeElement(ele) {
  ele.setAttribute('data-active', false);
}

function allCloseAccordions(nodeAll, parent) {
  return $Qll(nodeAll, parent).forEach((node) => {
    node.dataset.active = 'false';
  });
}

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
